/* eslint-disable @next/next/no-img-element */
import { ImageStorageBucket } from "@/utils/Constants";
import { useEffect, useState } from "react";

export function ImageLogo({
  college_name,
  country,
  customImageClass,
}: {
  customImageClass?: string;
  college_name: string;
  country: string;
}) {
  const [imgUrl, setImgUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true); // New loading state
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!college_name || !country) {
      setImgUrl(null);
      return;
    }

    const cleanedName = college_name.replace(/,\s*(uk|usa|uae|canada|germany|france|australia)$/i, "").trim();
    const formattedName = cleanedName
      .toLocaleLowerCase()
      .replace(/\s+/g, "_")
      .replaceAll(".", "");
    const cleanedCountry = country
      .toLocaleLowerCase()
      .replace(/^europe\s*-\s*/i, "")
      .trim()
      .replace(/\s+/g, "_");

    const initialUrl = `${ImageStorageBucket}/universities1/${cleanedCountry}/${formattedName}/media/${formattedName}_logo.webp`;
    setImgUrl(initialUrl);
    setHasError(false);
    setIsLoading(true);
  }, [college_name, country]);

  const handleError = () => {
    setHasError(true);
    setIsLoading(false);
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  if (hasError || !imgUrl) {
    return (
      <span className="flex w-full h-full items-center justify-center bg-blue-50/80 rounded-lg text-[#1776F0] font-bold text-xs">
        {college_name?.charAt(0) || "U"}
      </span>
    );
  }

  return (
    <span className="relative flex w-full h-full">
      {isLoading && (
        <div className="absolute animate-pulse rounded-md bg-slate-100 min-w-full min-h-full" />
      )}
      <img
        className={`object-contain object-center transition-opacity duration-300 w-full h-full ${
          isLoading ? "opacity-0" : "opacity-100"
        } ${customImageClass || ""}`}
        src={imgUrl}
        alt={college_name || ""}
        width={285}
        height={72}
        onLoad={handleLoad}
        onError={handleError}
      />
    </span>
  );
}
